import { http } from "@canvas/api";

export interface SwatchOutOfStockReq {
  endpoint: "ragnarok.swatch.v1.oos-requests";
  body: SwatchOutOfStockRequestBody;
}

export interface SwatchOutOfStockRequestBody {
  ec_id: string | number;
  sku_code: string | number;
  created_by: string | number;
}

export interface SwatchOutOfStockRes {}

export function post(req: SwatchOutOfStockReq): Promise<SwatchOutOfStockRes> {
  return http
    .POST(`/ragnarok/swatch/v1/oos-requests`, JSON.stringify(req.body))
    .then((response: SwatchOutOfStockRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
